// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar_container__3QUDx","icon":"avatar_icon__c9FdQ"};